import { formatCurrency } from '~libs/dataUtils';

/**
 * The one money and rate format on SaH budget screens (Budget Tracker and Dashboard).
 *
 * Signed AUD with two decimals, e.g. "$1,000.00" or "-$600.00".
 */
export const formatMoney = (value: number | null | undefined): string => formatCurrency(value ?? 0, 2);

/** A ratio (1 = 100%) as a percentage to one decimal place, or "n/a" when there is no divisor. */
export const formatRate = (ratio: number | null | undefined): string =>
  ratio === null || ratio === undefined || Number.isNaN(ratio) ? 'n/a' : `${(ratio * 100).toFixed(1)}%`;

/** Rule 7 (TAV-3459, TAV-3463): signed whole dollars, e.g. "$1,000" or "-$600". formatMoney is the exact amount. */
export const formatWholeMoney = (value: number | null | undefined): string =>
  formatCurrency(Math.round(value ?? 0) || 0, 0);

/** An amount over a limit in whole dollars: anything above zero shows as at least $1, never $0. */
export const formatOverAmount = (value: number): string =>
  formatWholeMoney(value > 0 ? Math.max(1, Math.round(value)) : 0);

/** Hours to two decimal places, e.g. "12.50" (care management by worker, TAV-3482). */
export const formatHours = (hours: number | null | undefined): string => (hours ?? 0).toFixed(2);
